import { render, staticRenderFns } from "./HeaderAssa.vue?vue&type=template&id=40beda25&scoped=true&"
import script from "./HeaderAssa.vue?vue&type=script&lang=js&"
export * from "./HeaderAssa.vue?vue&type=script&lang=js&"
import style0 from "./HeaderAssa.vue?vue&type=style&index=0&id=40beda25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40beda25",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VCol,VContent,VImg,VRow,VToolbarTitle})
